import styled from "styled-components";
import { tombac } from "../../shared/tombac";
import { PropsWithPropStyling, propStyling } from "../../shared";

export const ModalWindow = styled.div.attrs(() => ({
  className: "TombacModalWindow" as string,
}))<PropsWithPropStyling>`
  background-color: ${tombac.color.white};
  border-radius: ${tombac.unit(20)};
  box-shadow: ${tombac.unit(0, 2, 5, 0)} ${tombac.alpha("neutral", 24)};

  ${propStyling}
`;
